var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.72727C2 4.32545 2.31982 4 2.71429 4H21.2857C21.6786 4 22 4.32545 22 4.72727C22 5.12909 21.6786 5.45455 21.2857 5.45455H2.71429C2.31982 5.45455 2 5.12909 2 4.72727ZM2 12C2 11.6 2.31982 11.2727 2.71429 11.2727H21.2857C21.6786 11.2727 22 11.6 22 12C22 12.4 21.6786 12.7273 21.2857 12.7273H2.71429C2.31982 12.7273 2 12.4 2 12ZM21.2857 20H2.71429C2.31982 20 2 19.6727 2 19.2727C2 18.8727 2.31982 18.5455 2.71429 18.5455H21.2857C21.6786 18.5455 22 18.8727 22 19.2727C22 19.6727 21.6786 20 21.2857 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsLight);
export default __webpack_public_path__ + "static/media/bars-light.83da0034f9dd05446d99cb883855a48c.svg";
export { ForwardRef as ReactComponent };